<template>

<v-stepper alt-labels  v-model="estado" max-height="80px">
  <v-stepper-header>
  <template v-for="n in steps">
    <v-stepper-step  :key="`${n}-step`">
    {{ n }}
    </v-stepper-step>
    <v-divider
      v-if="n !== steps"
      :key="n"
    ></v-divider>
  </template>
  </v-stepper-header>
</v-stepper>
</template>
<script>
export default {
  data () {
    return {
      steps: 4,
      estado: 1
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {

  }
}
</script>
<style lang="scss">
.v-stepper__step__step{
  color: #FECD2F!important;
  i{
  color: #FECD2F!important;
  }
}
.paso-boton{
  padding: 0px 15px;
}
.pasos-header{
  height: 40px!important;
}
</style>
